import script from "./callTraceRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./callTraceRecord.vue?vue&type=script&setup=true&lang=js"

import "./callTraceRecord.vue?vue&type=style&index=0&id=44715f1a&lang=scss"

const __exports__ = script;

export default __exports__